//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "searchlogs",
  data() {
    return {
      visiableName: '',
      visiableUserid: '',
      isName: false,
      visiableUser: [],
      start: '',
      end: '',
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
    }
  },
  methods: {
    changeStartDate() {
      this.$vux.datetime.show({
        value: this.start, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: (event) => {
          this.start = event
        }
      })
    },
    changeEndDate() {
      this.$vux.datetime.show({
        value: this.end, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: (event) => {
          this.end = event
        }
      })
    },
    search() {
      this.$emit("search", {start: this.start, end: this.end, userid: this.visiableUserid});
    },
    choseVisiable(event) {
      this.visiableUserid = event.userid
      this.visiableName = event.name
      this.isName = false
    },
    getVisiableUser(value) {
      const hint = value ? value.target.value : ''
      this.$http.get('/api/v1/sale_logs/list_srvp_visible_to_me?offset=0&count=99&hint=' + hint, this.header).then(response => {
        this.visiableUser = response.data.content;
        this.isName = value;
      })
    }
  },
  created() {
    this.getVisiableUser('')
    const startDate = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-1')
    this.start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate()
    this.end = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
  }
}



// WEBPACK FOOTER //
// ./src/components/Saleslog/searchlogs.vue